import { api } from "@/lib/api/client";

import type { Client, ClientListResponse } from "./types";

interface Payload {
  first_name: string;
  last_name: string;
  phone?: string;
  email?: string;
  address?: string;
  notes?: string;
  is_active?: boolean;
  /** Clinique de rattachement. Omise = clinique active côté serveur. */
  organisation_id?: string;
}

export const clientsApi = {
  list: async (
    params: {
      search?: string;
      is_active?: boolean;
      date_from?: string;
      date_to?: string;
      page?: number;
      page_size?: number;
      ordering?: string;
    } = {},
  ): Promise<ClientListResponse> => {
    const { data } = await api.get<ClientListResponse>("/clients/", { params });
    return data;
  },
  get: async (id: string): Promise<Client> => {
    const { data } = await api.get<Client>(`/clients/${id}/`);
    return data;
  },
  create: async (payload: Payload): Promise<Client> => {
    const { data } = await api.post<Client>("/clients/", payload);
    return data;
  },
  update: async (id: string, payload: Partial<Payload>): Promise<Client> => {
    const { data } = await api.patch<Client>(`/clients/${id}/`, payload);
    return data;
  },
  remove: async (id: string): Promise<void> => {
    await api.delete(`/clients/${id}/`);
  },
};
